import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { SERVICES } from "../lib/data";

export default function Services() {
  return (
    <>
      <PageHeader
        eyebrow="Our services"
        title={<span className="text-yellow-400">One contract. Every discipline.</span>}
        sub="From concept to handover, Alex Interiors delivers a complete turnkey package — design, carpentry, civil, plumbing, electrification, networking, HVAC and life-safety systems."
        image="https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=2400&q=85"
      />

      <section className="bg-[#FAFAFA] py-24 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {SERVICES.map((s, i) => (
              <article
                key={s.title}
                data-testid={`service-card-${i}`}
                className="bg-white group hover:bg-[#0A192F] transition-colors duration-500"
              >
                <div className="img-zoom aspect-[16/10]">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-7">
                  <span className="text-xs text-[#C5A059] tracking-widest">SERVICE 0{i + 1}</span>
                  <h3 className="font-heading text-xl sm:text-2xl font-semibold mt-3 text-[#0A192F] group-hover:text-white transition-colors">
                    {s.title}
                  </h3>
                  <p className="text-sm text-[#475569] mt-3 leading-relaxed group-hover:text-white/70 transition-colors">
                    {s.short}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#0A192F] text-white py-20">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            <p className="eyebrow">Need multiple services?</p>
            <h3 className="font-heading text-3xl sm:text-4xl font-bold mt-3">
              Bundle them into a single turnkey contract.
            </h3>
          </div>
          <Link
            to="/contact"
            data-testid="services-cta"
            className="inline-flex items-center gap-2 bg-[#C5A059] text-[#0A192F] px-8 py-4 text-sm font-semibold hover:bg-white transition-colors"
          >
            Get in Touch <ArrowUpRight size={16} />
          </Link>
        </div>
      </section>
    </>
  );
}
